<template>
  <div style="margin-bottom: 15px;">
    <div class="overlay" v-if="!isEmpty(post)" style="position: fixed; top: 0; left: 0; height: 100%; width: 100%; z-index: 30"></div>

    <div style="position: relative" :style="`height: ${new_post_box_height}px`">
      <div class="box is-boxed-3" id="newpostbox" ref="newpostbox" style="position: absolute; width: 100%;" :style="!isEmpty(post) ? 'z-index: 31;' : ''">
        <p class="title font-14 has-text-primary2 font-w-600">Bagikan sesuatu di kelas Anda:</p>
        <!-- Material Types -->
        <div class="columns is-vcentered is-centered is-multiline is-mobile" v-if="isEmpty(post)">
          <div class="column is-3-desktop has-text-centered is-4-mobile" v-for="(t, i) in material_types" :key="i" :class="{'has-background-white-ter': !isEmpty(hover_post_type) && hover_post_type == t.value}" @mouseenter="hover_post_type = t.value" @mouseleave="hover_post_type = null" style="border-radius: 8px;">
            <a href="" class="is-block" @click.prevent="onPostTypeClicked(t.value)">
              <figure class="image is-48x48" style="margin: 0 auto;" :class="{'animated rubberBand': !isEmpty(hover_post_type) && hover_post_type == t.value}">
                <img :src="t.icon" alt="">
              </figure>
              <p class="has-text-grey font-w-500"><small>{{ t.text }}</small></p>
            </a>
          </div>
        </div>

        <div v-else style="margin: -17px;" class="animated fadeIn">
          <b-tabs v-model="tab" expanded id="new-post-box-tabs">
            <b-tab-item icon="arrow-left"></b-tab-item>

            <b-tab-item :label="isEmpty(group_id) ? 'Pilih Kelas & Sesi' : 'Pilih Sesi'" v-if="isEmpty(group_id) || (!isEmpty(group_id) && (['I', 'S', 'E'].indexOf(post.type) <= -1))">
              <b-field :label="`Di kelas mana ${getPostTypes(post.type)} akan dibagikan?`" v-if="isEmpty(group_id)">
                <b-autocomplete
                  field="display"
                  class="m-input"
                  :data="classes"
                  placeholder="Cari Mata Kuliah / Nama Kelas"
                  :open-on-focus="true"
                  :check-infinite-scroll="true"
                  :loading="loading_get_all_class_lists"
                  @typing="getDelayClasses"
                  @infinite-scroll="getDelayMoreClasses"
                  @select="option => selectClass(option)"
                  style="border-bottom: none !important;"
                >
                  <template slot-scope="props">
                    <div class="columns is-mobile is-vcentered">
                      <div class="column">
                        <h3><strong>{{ props.option.name }}</strong></h3>
                        <small>{{ props.option.className || '-' }}</small>
                      </div>
                    </div>
                  </template>
                </b-autocomplete>
              </b-field>

              <b-field :label="`Di sesi berapa ${getPostTypes(post.type)} akan dibagikan?`" v-if="['I', 'S', 'E'].indexOf(post.type) <= -1">
                <b-dropdown :disabled="isEmpty(selected_class)" aria-role="list" style="width: 70%;">
                  <button class="button" type="button" slot="trigger" :disabled="isEmpty(selected_class)">
                    <template v-if="isEmpty(selected_section)">
                      <span>Pilih Sesi</span>
                    </template>
                    <template v-else-if="!isEmpty(selected_section) && isEmpty(selected_section.id)">
                      <span>Sesi Baru</span>
                    </template>
                    <template v-else>
                      <span><strong>Sesi {{ selected_section.meet }}</strong></span>
                    </template>
                    <b-icon icon="menu-down"></b-icon>
                  </button>

                  <b-dropdown-item v-if="!isEmpty(selected_class) && selected_class.type !== 'ACADEMIC'" value="0" aria-role="listitem" :style="!isEmpty(sections) ? 'border-bottom: 1px solid #e3e3e3;' : ''" @click="selectSection">
                    <div class="media">
                      <b-icon class="media-left" icon="plus"></b-icon>
                      <div class="media-content">
                        <h3>Buat Sesi Baru</h3>
                      </div>
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-item v-else-if="!isEmpty(selected_class) && selected_class.type === 'ACADEMIC' && sections.length === 0" value="0" aria-role="listitem" :style="!isEmpty(sections) ? 'border-bottom: 1px solid #e3e3e3;' : ''" @click="$router.push(`/panel/classes`)">
                    <div class="media">
                      <div class="media-content">
                        <h3>Klik disini untuk sinkron kelas</h3>
                      </div>
                    </div>
                  </b-dropdown-item>

                  <b-dropdown-item v-for="(section, key) in sections" :key="key" :value="key" aria-role="listitem" @click="selectSection(section)">
                    <div class="media">
                      <div class="media-content">
                        <h3><strong>Sesi {{ section.meet }}</strong></h3>
                        <small>{{ section.topic || '-' }}</small>
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-dropdown>
              </b-field>

              <!-- Sesi Baru -->
              <div v-if="!isEmpty(selected_section)" style="margin-bottom: 15px;">
                <b-field label="Topik Sesi">
                  <b-input expanded placeholder="Topik Sesi" v-model="selected_section.topic" :disabled="!isEmpty(selected_section.progress) && selected_section.progress !== 'S'"></b-input>
                </b-field>
              </div>

              <div class="columns" v-if="(['I', 'S', 'E'].indexOf(post.type) > -1 && !isEmpty(selected_class)) || (['I', 'S', 'E'].indexOf(post.type) <= -1 && !isEmpty(selected_section))">
                <div class="column"></div>
                <div class="column is-narrow">
                  <button v-if="post.type !== 'Z'" class="button is-primary" @click.prevent="tab += 1" :disabled="(!isEmpty(selected_section) && isEmpty(selected_section.topic) && ((!isEmpty(selected_section.progress) && selected_section.progress === 'S') || isEmpty(selected_section.progress))) || isEmpty(selected_class)">
                    <span>Langkah Berikutnya</span>
                    <span class="icon"><i class="fas fa-chevron-right"></i></span>
                  </button>
                  <button v-else class="button is-primary" :class="{'is-loading': loading_create_quiz, 'is-disabled': loading_create_quiz}" @click.prevent="createQuiz" :disabled="loading_create_quiz">
                    <span>Buat Quiz</span>
                  </button>
                </div>
              </div>
            </b-tab-item>

            <b-tab-item v-if="post.type !== 'Z'" :label="`Atur ${getPostTypes(post.type)}`" :disabled="(['I', 'S', 'E'].indexOf(post.type) > -1 && isEmpty(selected_class)) || (['I', 'S', 'E'].indexOf(post.type) <= -1 && isEmpty(selected_section))">
              <div style="margin-bottom: 20px;" v-if="(['I', 'S', 'E'].indexOf(post.type) > -1 && !isEmpty(selected_class)) || (['I', 'S', 'E'].indexOf(post.type) <= -1 && !isEmpty(selected_section))">
                <b-field label="Kelas">
                  <b-input expanded :value="selected_class.display" disabled></b-input>
                </b-field>

                <b-field v-if="!isEmpty(selected_section)" :label="`Sesi ${!isEmpty(selected_section.id) ? selected_section.meet : (sections.length + 1)}`">
                  <b-input expanded :value="selected_section.topic" disabled></b-input>
                </b-field>

                <b-field :label="`Judul ${getPostTypes(post.type)}`">
                  <b-input v-model="post.title" expanded :placeholder="`Judul ${getPostTypes(post.type)}`" maxlength="255" required></b-input>
                </b-field>

                <label class="label" v-if="post.type === 'V' && canIntegrateGoogleMeet">
                  <span>Pilih Media Conference</span>
                </label>
                <div class="columns is-vcentered" v-if="post.type === 'V' && canIntegrateGoogleMeet">
                  <div class="column is-6">
                    <div class="field box is-boxed-3" style="display: flex; flex-direction: row; align-items: center; padding: 1.15rem 1rem;" :style="post.conference_type == 'ZOOM' ? 'border: 1px solid #279B24;' : ''">
                      <b-radio v-model="post.conference_type"
                          name="conference_type"
                          native-value="ZOOM"
                          class="font-16 has-text-black">
                          Zoom
                      </b-radio>
                    </div>
                  </div>
                  <div class="column is-6">
                    <div class="field box is-boxed-3" style="display: flex; flex-direction: row; align-items: center;" :style="post.conference_type == 'GMEET' ? 'border: 1px solid #279B24;' : ''">
                      <b-radio v-model="post.conference_type"
                          name="conference_type"
                          native-value="GMEET"
                          class="font-16 has-text-black">
                          Google Meet
                      </b-radio>
                      <span class="button is-primary5 is-small font-w-500 font-12" style="border-radius: 4px;">Baru</span>
                    </div>
                  </div>
                </div>

                <div class="columns is-vcentered is-mobile" style="margin-bottom: 0;" v-if="['M', 'Q', 'I', 'S', 'E'].indexOf(post.type) > -1">
                  <div class="column">
                    <label class="label">
                      <span>Berkas (Dokumen, Gambar, Video)</span>
                    </label>
                  </div>

                  <div class="column is-narrow">
                    <a class="button is-light is-small" @click.prevent="showMediaLibraryModal(['document', 'image', 'youtube', 'video'])">
                      <span class="icon">
                        <i class="fas fa-paperclip"></i>
                      </span>

                      <span>Tambah Berkas</span>
                    </a>
                  </div>
                </div>

                <div class="field" v-if="['M', 'Q', 'I', 'S', 'E'].indexOf(post.type) > -1">
                  <div class="control">
                    <div class="box has-background-white-bis" style="padding: 10px;">
                      <div v-if="!isEmpty(selected_medias)">
                        <div class="columns is-mobile is-vcentered is-gapless" v-for="(media, index) in selected_medias" :key="index" style="margin-bottom: 0;">
                          <div class="column truncated-text">
                            <div class="columns is-mobile is-vcentered is-gapless">
                              <div class="column is-narrow" style="margin-right: 10px;">
                                <icon-collection :media="media" size="is-16x16"></icon-collection>
                              </div>
                              <div class="column">
                                <span><small>{{ media.name }}</small></span>
                              </div>
                            </div>
                          </div>
                          <div class="column is-narrow">
                            <a class="button is-text has-text-danger" @click.prevent="deleteMedia([media.id])">
                              <i class="fas fa-trash"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <p v-else class="has-text-grey">Tidak ada berkas.</p>
                    </div>
                  </div>
                </div>

                <!-- Survei -->
                <b-field label="Tipe" v-if="post.type == 'S'">
                  <div class="block">
                    <b-radio v-model="post.survey.survey_type" native-value="S">Satu Pilihan</b-radio>
                    <b-radio v-model="post.survey.survey_type" native-value="M">Banyak Pilihan</b-radio>
                  </div>
                </b-field>

                <b-field label="Opsi" v-if="post.type == 'S'">
                  <survey-creator :onChangeChoices="onChangeSurveyChoices"></survey-creator>
                </b-field>

                <!-- Event -->
                <b-field label="Acara" v-if="post.type == 'E'">
                  <event-creator :onChangeEvent="onChangeEvent"></event-creator>
                </b-field>
              </div>

              <div class="columns">
                <div class="column"></div>
                <div class="column is-narrow">
                  <button class="button is-primary" @click.prevent="shareTab" :disabled="isEmpty(post.title) || (post.type === 'Z' && !isEmpty(selected_question))">
                    <span>Langkah Berikutnya</span>
                    <span class="icon"><i class="fas fa-chevron-right"></i></span>
                  </button>
                </div>
              </div>
            </b-tab-item>

            <b-tab-item v-if="post.type !== 'Z'" :label="`Bagikan ${getPostTypes(post.type)}`" :disabled="isEmpty(post.title)">
              <b-field label="Catatan">
                <txteditor :editText="true" :text="post.description" :onUpdate="(text) => post['description'] = text" :toolbars="text_editor_toolbars" contentStyle="max-height: 200px !important; overflow-y: auto !important;" :show_leave_page_confirmation="false"></txteditor>
              </b-field>

              <!-- Assigment Deadline -->
              <div class="columns is-vcentered" v-if="post.type == 'Q'">
                <div class="column is-6">
                  <div class="field">
                    <label class="label">
                      <span>Tambahkan Batas Waktu Penyerahan?</span>
                    </label>
                    <div class="control">
                      <b-switch v-model="teacher_question_due_date">{{ teacher_question_due_date ? 'Ya' : 'Tidak' }}</b-switch>
                    </div>
                  </div>
                </div>
                <div class="column is-6" v-if="teacher_question_due_date">
                  <div class="field">
                    <label class="label">
                      <span>Pilih Batas Tanggal & Waktu</span>
                    </label>
                    <div class="control">
                      <datetime-picker :datetime="post.teacher_question.due_date" :onChange="(datetime) => post['teacher_question']['due_date'] = datetime"></datetime-picker>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns is-vcentered">
                <div class="column is-6">
                  <div class="field">
                    <label class="label">
                      <span>Kapan {{ getPostTypes(post.type) }} akan dibagikan?</span>
                    </label>
                    <div class="control">
                      <div>
                        <div class="columns is-gapless">
                          <div class="column">
                            <b-field>
                              <b-radio-button
                                v-model="post.status"
                                native-value="A"
                                type="is-primary"
                              >
                                <span class="icon"><i class="fa fa-check"></i></span>
                                <span>Sekarang</span>
                              </b-radio-button>
                              <b-radio-button
                                v-model="post.status"
                                native-value="D"
                                type="is-light"
                                style="margin-left: 7px;"
                              >
                                <span class="icon"><i class="fas fa-clock has-text-primary"></i></span>
                                <span class="has-text-primary">Nanti</span>
                              </b-radio-button>
                            </b-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-6" v-if="post.status == 'D'">
                  <div class="field">
                    <label class="label">
                      <span>Jadwalkan, Pilih Tanggal & Waktu</span>
                    </label>
                    <div class="control">
                      <datetime-picker :datetime="post.published_at" :onChange="(datetime) => post['published_at'] = datetime"></datetime-picker>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns is-gapless is-mobile" style="margin: 0 -17px -17px">
                <div class="column">
                  <button type="button" class="btn-cancel button is-fullwidth is-medium is-light" @click.prevent="exitPostCreation" :disabled="loading_share" :class="{'is-loading': loading_share}">Batal</button>
                </div>
                <div class="column" v-if="post.status == 'D'">
                  <button type="button" @click.prevent="share(false)" class="btn-submit button is-fullwidth is-medium is-primary" :disabled="loading_share" :class="{'is-loading': loading_share}">
                    <span class="icon">
                      <i class="fas fa-clock"></i>
                    </span>
                    <span>Bagikan Nanti</span>
                  </button>
                </div>
                <div class="column" v-if="post.status == 'A'">
                  <button type="button" @click.prevent="share(false)" class="btn-submit button is-fullwidth is-primary is-medium" :disabled="loading_share" :class="{'is-loading': loading_share}">
                    <span class="icon">
                      <i class="fas fa-check"></i>
                    </span>
                    <span>Bagikan Sekarang</span>
                  </button>
                </div>
              </div>
            </b-tab-item>
          </b-tabs>
        </div>
      </div>
    </div>

    <b-modal
      :active.sync="show_media_library_modal"
      v-if="!isEmpty(post) && ['M', 'Q', 'I', 'S', 'E'].indexOf(post.type) > -1"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal>
      <form action="">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head has-background-primary">
            <p class="modal-card-title has-text-white">Media Library</p>
          </header>
          <section class="modal-card-body">
            <media-library
              :selected_ids="selected_media_ids"
              :multiple="true"
              :types="media_types"
              :mediaCatcher="mediaCatcher"
              :max="5"
              :onClickCancel="() => show_media_library_modal = false"
            ></media-library>
          </section>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { POST, LEARNING_MATERIAL, INTEGRATION } from '~/consts'
import MEDIA_MIXIN from '~/mixins/medias';
import CLASS_MIXIN from '~/mixins/classes';
import SECTION_MIXIN from '~/mixins/sections';
import SurveyCreator from '~/components/molecules/SurveyCreator'
import EventCreator from '~/components/molecules/EventCreator'
import TextEditor from '~/components/TextEditor';
import DatetimePicker from '~/components/DateTimePicker';

export default {
  mixins: [MEDIA_MIXIN, CLASS_MIXIN, SECTION_MIXIN],

  components: {
    SurveyCreator,
    EventCreator,
    'txteditor': TextEditor,
    DatetimePicker
  },

  props: {
    group_id: {
      type: Number,
      default: null
    },
    onSharePostSuccess: {
      type: Function,
      default: () => {}
    },
    onSharePostFailed: {
      type: Function,
      default: () => {}
    },
    post_types: {
      type: Array,
      default: () => ['M', 'Q', 'Z', 'V', 'I', 'S', 'E']
    }
  },

  mounted() {
    this.new_post_box_height = this.$refs.newpostbox.offsetHeight;

    if (!this.isEmpty(this.$route.query.status) && !this.isEmpty(this.$cookies.get('_postdata'))) {
      if (this.$route.query.status === "done")
        this.share(true);
      else {
        this.$cookies.remove('_postdata');
        this.onSharePostSuccess();
        this.$buefy.toast.open({
          message: "Gagal menyambungkan akun, silahkan posting dan sambungkan ulang",
          type: 'is-danger'
        });
      }
    }
  },

  computed: {
    ...mapState({
      auth: state => state.auth
    }),
    material_types() {
      let types = [
        { value: 'M', text: 'Materi', icon: '/assets/img/icon/material.svg'},
        { value: 'Q', text: 'Tugas', icon: '/assets/img/icon/assign.svg'},
        { value: 'Z', text: 'Quiz', icon: '/assets/img/icon/quiz.svg'},
        { value: 'V', text: 'Live Conference', icon: '/assets/img/icon/conference.svg'},
        { value: 'I', text: 'Info', icon: '/assets/img/icon/info.svg'},
        { value: 'S', text: 'Survei', icon: '/assets/img/icon/survey.svg'},
        { value: 'E', text: 'Acara', icon: '/assets/img/icon/event.svg'},
        { value: 'other', text: this.show_all_material_types ? 'Sembunyikan' : 'Lainnya', icon: '/assets/img/icon/other-icon.svg', hide: false},
      ]
      let post_types = _.cloneDeep(this.post_types)
      if (post_types.length > 3) {
        post_types.push('other')
      }

      types = collect(types).whereIn('value', post_types).map((type, key) => {
        if (type.value != 'other') {
          if (key > 2) {
            type['hide'] = true
          } else {
            type['hide'] = false
          }
        }

        return type;
      })

      if (!this.show_all_material_types) {
        types = types.where('hide', false)
      }

      return types.toArray();
    },
    canIntegrateZoomInAcademicClass() {
      return !this.isEmpty(this.auth.activeAccount) && this.auth.activeAccount.permissionNames.includes("can_integrate_zoom_academic_class") === true;
    },
    canIntegrateZoomInGeneralClass() {
      return !this.isEmpty(this.auth.activeAccount) && this.auth.activeAccount.permissionNames.includes("can_integrate_zoom_general_class") === true;
    },
    canIntegrateGoogleMeet() {
      return !this.isEmpty(this.auth.activeAccount) && this.auth.activeAccount.permissionNames.includes("can_integrate_google_meet") === true;
    },
    class_types() {
      let types = [];

      if (this.post.type === 'V') {
        if (this.canIntegrateZoomInAcademicClass) {
          types.push("A");
        }

        if (this.canIntegrateZoomInGeneralClass) {
          types.push("C", "E");
        }
      } else {
        types = ['C', 'E', 'A']
      }

      return types;
    },
    selected_media_ids() {
      return collect(this.selected_medias).pluck('id').toArray()
    },
    teacher_question_due_date: {
      get() {
        return this.isEmpty(this.post.teacher_question.due_date) ? false : true
      },
      set() {
        this.setTeacherQuestionFinishedAt();
      }
    },
    quiz_finished_at: {
      get() {
        return this.isEmpty(this.post.quiz.finished_at) ? false : true
      },
      set(val) {
        this.setQuizFinishedAt();
      }
    },
    post_status() {
      if (this.isEmpty(this.post)) {
        return 'A'
      }

      return this.post.status
    },
    quiz_duration: {
      get() {
        return parseFloat(this.post.quiz.duration / 60).toFixed(0);
      },
      set(val) {
        let duration = this.post.quiz.duration;
        if (val <= 0) {
          duration = 1;
          toast.danger(`Durasi harus diisi minimal 1 menit`);
        }
        if (val > this.quiz_duration_max) {
          duration = this.quiz_duration_max;
          toast.danger(`Durasi tidak dapat lebih dari ${this.quiz_duration_max} menit`);
        }
        duration = parseInt(val) * this.quiz_duration_unit
        this.post.quiz.duration = duration;
      }
    },
    quiz_is_retakeable: {
      get() {
        return this.post.quiz.is_retakeable ? true : false
      },
      set(val) {
        this.post.quiz.is_retakeable = val ? 1 : 0;
      }
    },
    quiz_pause_retake_duration: {
      get() {
        return parseFloat(this.post.quiz.pause_retake / 60).toFixed(0);
      },
      set(val) {
        let pause_retake = this.post.quiz.pause_retake;
        if (val > this.pause_retake_max) {
          pause_retake = this.pause_retake_max;
          toast.danger(`Jeda quiz diulang tidak dapat lebih dari 1440 menit`);
        }
        pause_retake = parseInt(val) * this.pause_retake_unit
        this.post.quiz.pause_retake = pause_retake;
      }
    },
  },

  watch: {
    show_all_material_types() {
      Vue.nextTick(() => {
        this.new_post_box_height = this.$refs.newpostbox.offsetHeight;
      })
    },
    post_status(val) {
      if (!this.isEmpty(this.post)) {
        if (val == 'D') {
          this.post['published_at'] = moment().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss')
        } else if (val == 'A') {
          this.post['published_at'] = null
        }
      }
    },
    tab(index, oldIndex) {
      if (index == 0 && !this.isEmpty(this.post)) {
        this.exitPostCreation(oldIndex);
      }
    },
  },

  data() {
    return {
      loading_share: false,
      show_all_material_types: false,
      new_post_box_height: 0,
      text_editor_toolbars: ['bold', 'italic', 'strike', 'underline', 'code', 'paragraph', 'heading1', 'heading2', 'heading3', 'paragraph_left', 'paragraph_center', 'paragraph_right', 'paragraph_justify', 'bullet_list', 'ordered_list', 'undo', 'redo'],
      media_types: ['document', 'image', 'youtube'],
      hover_post_type: null,
      hover_media: null,
      tab: 0,
      post: null,
      classes: [],
      sections: [],
      selected_class: null,
      selected_section: null,
      selected_medias: [],
      selected_question: null,
      pause_retake_unit: 60,
      quiz_duration_unit: 60,
      total_quiz_question_scores: 0,
      quiz_use_grade_limit: false,
      quiz_duration_max: 1440,
      pause_retake_max: 1440,
      loading_create_quiz: false,
      conference_type: 'ZOOM'
    }
  },

  methods: {
    onPostTypeClicked(type) {
      if (type == 'other') {
        this.show_all_material_types = !this.show_all_material_types
        return
      }

      let post = null;

      switch(type) {
        case 'M':
          post = {
            type: 'M',
          }
          break;

        case 'Q':
          post = {
            type: 'Q',
            teacher_question: {
              due_date: moment().add(3, 'hour').format('YYYY-MM-DD HH:mm:ss')
            }
          }
          break;

        case 'Z':
          post = {
            type: 'Z',
            quiz: {
              type: 0,
              status: 0,
              show_report_to_members: true,
              grade_limit: 0,
              is_retakeable: 0,
              pause_retake: null,
              max_retake: null,
              finished_at: moment().add(3, 'hour').format('YYYY-MM-DD HH:mm:ss'),
              grade_limit: 0
            }
          }
          break;

        case 'V':
          post = {
            type: 'V',
            conference_type: 'ZOOM'
          }
          break;

        case 'I':
          post = {
            type: 'I',
          }
          break;

        case 'S':
          post = {
            type: 'S',
            survey: {
              survey_type: 'S',
              choices: []
            }
          }
          break;

        case 'E':
          post = {
            type: 'E',
            event: {
              location: null,
              started: moment().format('YYYY-MM-DD HH:mm:ss'),
              end_at: null
            }
          }
          break;
      }

      post['status'] = 'A'
      post['description'] = ''
      post['published_at'] = null

      this.tab = 1;
      this.post = post
      this.selected_class = null
      this.selected_section = null

      // If Class Defined at first
      if (!this.isEmpty(this.group_id)) {
        this.allClassListsDataProvider['criterion'] = [{
          criteria: 'id',
          operator: 'EQ',
          value: this.group_id
        }];
      }

      if (['M', 'Q', 'Z', 'V'].indexOf(post.type) > -1) {
        this.allClassListsDataProvider['criterion'] = this.convertToCriterionDataProvider(this.allClassListsDataProvider.criterion, {
          criteria: 'scope',
          operator: 'EQ',
          value: 'O,A',
          custom: true
        });
      } else {
        this.allClassListsDataProvider['criterion'] = this.convertToCriterionDataProvider(this.allClassListsDataProvider.criterion, {
          criteria: 'scope',
          operator: 'EQ',
          value: '',
          custom: true
        });
      }

      // If Conference show academic classes only
      // if (post.type == 'V') {
      //   this.allClassListsDataProvider['criterion'] = this.convertToCriterionDataProvider(this.allClassListsDataProvider.criterion, {
      //     criteria: 'type',
      //     operator: 'EQ',
      //     value: 'A'
      //   });
      // } else {
        this.allClassListsDataProvider['criterion'] = this.convertToCriterionDataProvider(this.allClassListsDataProvider.criterion, {
          criteria: 'type',
          operator: 'EQ',
          value: ''
        });
      // }

      Vue.nextTick(() => {
        this.getClassLists(true, this.class_types);
      })
    },
    getDelayClasses: _.debounce(function(name) {
      this.allClassListsDataProvider['criterion'] = collect(this.allClassListsDataProvider.criterion).map(c => {
        if (c.criteria == 'name,class_name') {
          c['value'] = name
        }

        return c
      }).toArray()

      Vue.nextTick(() => {
        this.getClassLists(true, this.class_types)
      })
    }, 500),
    onGetClassListsSuccess(res, refresh) {
      let classes = collect(res.data.data).map((c) => {
        c['display'] = !this.isEmpty(c.className) ? `${c.name} (${c.className})` : c.name;

        return c
      }).toArray()

      if (!refresh) {
        classes = this.classes.concat(classes)
      }

      this.classes = classes
      this.allClassListsDataProvider = res.data.dataProvider

      if (!this.isEmpty(this.group_id)) {
        Vue.nextTick(() => {
          this.selectClass(classes[0]);
        })
      }
    },
    selectClass(c) {
      if (this.isEmpty(c)) {
        return;
      }

      this.selected_class = c
      this.post['group_id'] = c.id
      this.selected_section = null

      this.getSections(c.id)
    },
    onGetSections(res) {
      this.sections = !this.isEmpty(res.data) ? res.data : []
    },
    selectSection(section) {
      if (this.isEmpty(section) || this.isEmpty(section.id)) {
        this.selected_section = {
          topic: ''
        }
      } else {
        this.selected_section = section
      }
    },
    showMediaLibraryModal(types) {
      this.media_types = types;

      Vue.nextTick(() => {
        this.show_media_library_modal = true
      })
    },
    mediaCatcher(medias) {
      const vm = this;
      let ref = vm.media_types

      medias = collect(medias).whereIn('type', ref);
      let videos_count = medias.whereIn('type', ['video', 'youtube']).count();

      if (videos_count > 1) {
        toast.danger('Video / Youtube maksimal 1 item');
        return;
      }

      this.selected_medias = medias.toArray()

      this.show_media_library_modal = false
    },
    setQuizFinishedAt() {
      if (this.post.type == 'Z') {
        if (!this.isEmpty(this.post.quiz.finished_at)) {
          this.post.quiz.finished_at = null;
        } else {
          this.post.quiz.finished_at = moment().add(3, 'hour').format('YYYY-MM-DD HH:mm:ss');
        }
      }
    },
    setTeacherQuestionFinishedAt() {
      if (this.post.type == 'Q') {
        if (!this.isEmpty(this.post.teacher_question.due_date)) {
          this.post.teacher_question.due_date = null;
        } else {
          this.post.teacher_question.due_date = moment().add(3, 'hour').format('YYYY-MM-DD HH:mm:ss');
        }
      }
    },
    deleteMedia(media_ids) {
      const vm = this;

      this.selected_medias = collect(this.selected_medias).filter((m) => {
        return media_ids.indexOf(m.id) <= -1
      }).toArray()
    },
    scrollToBox() {
      let top_position = this.$refs.newpostbox.offsetTop;

      window.scrollTo(0, top_position);
    },
    getDelayMoreClasses: _.debounce(function(name) {
      if (!this.isEmpty(this.allClassListsDataProvider.page.next) && this.allClassListsDataProvider.page.next > this.allClassListsDataProvider.page['current']) {
        this.allClassListsDataProvider.page['current'] = this.allClassListsDataProvider.page.next

        Vue.nextTick(() => {
          this.getClassLists(false, this.class_types)
        })
      }
    }, 500),
    savePostdataToCookies() {
      const vm = this;
      const postdata = this.getPostData();
      this.$cookies.set('_postdata', postdata);
    },
    async share(oAuthCallback = false) {
      const vm = this

      if (vm.loading_share) {
        return;
      }

      vm.loading_share = true

      let postdata = (oAuthCallback) ? this.$cookies.get('_postdata') : this.getPostData();
      if (this.isEmpty(postdata)) {
        vm.loading_share = true
        return;
      }

      if (postdata.conference_type === 'GMEET' && !oAuthCallback) {
        const { data } = await this.$axios.post(INTEGRATION.CALENDAR_LIST);

        if (data.applicationSystem.code !== 0) {
          const token = this.getToken();
          if (!this.isEmpty(token)) {
            this.savePostdataToCookies();
            window.location.href = `${this.get_api_url()}${INTEGRATION.GOOGLE_CALENDAR(token, this.$route.fullPath.slice(1))}`;
          } else {
            vm.$buefy.toast.open({
              message: "Terjadi kesalahan saat menyambungkan akun, silahkan login kembali",
              type: 'is-danger'
            });
            this.loading_share = false;
            return;
          }
        }
      }

      this.$axios.post(POST.SHARE_GLOBAL_TIMELINE, postdata)
        .then(({ data }) => {
          this.$cookies.remove('_postdata');
          if (data.applicationSystem.code == 0) {
            vm.onSharePostSuccess();
            this.ga_send_event(this.auth, {
              dimension8: this.selected_class.id,
              dimension9: this.selected_class.name,
              dimension10: this.getGroupType(this.selected_class.type),
              dimension11: data.data.id,
              dimension12: data.data.title,
              dimension13: data.data.type,
              metric2: 1
            });

            this.resetData()
            vm.$buefy.toast.open({
              message: data.applicationSystem.message,
            });
          } else {
            vm.onSharePostFailed();

            vm.$buefy.toast.open({
              message: data.applicationSystem.message,
              type: 'is-danger'
            })
          }
          vm.loading_share = false
        }).catch(() => {
          vm.onSharePostFailed();

          vm.loading_share = false
        })
    },
    onQuizQuestionAdded(questions) {
      this.total_quiz_question_scores = collect(questions).map(question => {
        question.score = parseInt(question.score);
        return question;
      }).sum("score");
      this.post.quiz['questions'] = questions
    },
    getPostData() {
      const vm = this
      let postdata = Object.assign({}, this.post, {
        media_ids: this.selected_media_ids,
      })

      if (!this.isEmpty(this.selected_section)) {
        postdata['section'] = {
          id: !this.isEmpty(this.selected_section.id) ? this.selected_section.id : null,
          topic: this.selected_section.topic,
        }
      }

      switch (this.post.type) {
        case 'Z':
          if (postdata.quiz.is_retakeable == 1) {
            if (postdata.quiz.max_retake > 10) {
              toast.danger('Maksimal quiz diulang tidak bisa lebih dari 10');
              return;
            }

            if (postdata.quiz.pause_retake > 86400) {
              toast.danger('Jeda quiz diulang tidak bisa lebih dari 24 Jam');
              return;
            }
          }
          break;
      }

      return postdata
    },
    resetData() {
      this.loading_share = false
      this.hover_post_type = null
      this.hover_media = null
      this.tab = 0
      this.post = null
      this.classes = []
      this.sections = []
      this.selected_class = null
      this.selected_section = null
      this.selected_medias = []
    },
    onChangeSurveyChoices(choices) {
      this.post.survey['choices'] = choices
    },
    onChangeEvent(event) {
      this.post['event'] = event
    },
    shareTab() {
      switch(this.post.type) {
        case 'Z':
          if (this.isEmpty(this.post.quiz.duration) || this.post.quiz.duration == 0) { toast.danger('Durasi harus diisi'); return; }
          if (this.isEmpty(this.post.quiz.questions)) { toast.danger('Pertanyaan harus diisi, minimal 1 pertanyaan'); return; }
          if (!this.isEmpty(this.post.quiz.questions)) {
            const valid = this.validateQuiz();

            if (!valid) {
              return;
            }
          }
          break;
      }

      this.tab = this.tab + 1
    },
    validateQuiz() {
      return this.post.quiz.questions.every((question, index) => {
        if (this.post.quiz.type == 0 && (this.isEmpty(question.score) || question.score <= 0)) {
          toast.danger(`Lengkapi bobot pertanyaan nomor #${question.order + 1}`);
          return false;
        }

        if (this.isEmpty(question.body)) {
          toast.danger('Pertanyaan harus diisi');
          return false;
        }

        if (this.isEmpty(question.answers)) {
          toast.danger(`Jawaban Pertanyaan #${question.order + 1} harus diisi`);
          return false;
        }

        const isContinue = question.answers.every((answer, aindex) => {
          if (this.isEmpty(this.strip_tags(answer.body))) {
            toast.danger(`Jawaban ${this.keyAlphabet(aindex)} pada Pertanyaan #${question.order + 1} harus diisi`);
            return false;
          }

          return true
        });

        if (!isContinue) {
          return false;
        }

        return true;
      })
    },
    async createQuiz() {
      if (this.loading_create_quiz) {
        return;
      }

      this.loading_create_quiz = true;

      let section = this.selected_section;
      if (this.isEmpty(section.progress) || section.progress === 'S') {
        try {
          if (!this.isEmpty(this.selected_section.id)) {
            section = await this.updateSection({
              id: this.selected_section.id,
              topic: this.selected_section.topic
            })
          } else {
            section = await this.addSection(this.selected_class.id, {
              topic: this.selected_section.topic
            })
          }

          if (this.isEmpty(section)) {
            throw new Error;
          }


        } catch (e) {
          this.loading_create_quiz = false;
          return;
        }
      }

      try {
        let {data} = await this.$axios
          .post(LEARNING_MATERIAL.ADD(section.id), {
            type: "Z",
          });

        if (data.applicationSystem.code == 0) {
          const url = this.$router.resolve({
            name:
              this.selected_class.type === "ACADEMIC"
                ? "panel-classes-id-sections-section_id-learningmaterial_id"
                : "panel-groups-id-sections-section_id-learningmaterial_id",
            params: {
              id: this.selected_class.id,
              section_id: section.id,
              learningmaterial_id: data.data.id,
            },
            query: this.$route.query,
          });

          this.$router.push(url.href);
        } else {
          toast.danger(data.applicationSystem.message);
          throw new Error;
        }
      } catch (e) {
        this.loading_create_quiz = false;
      }
    },
    exitPostCreation(oldIndex = null) {
      this.$buefy.dialog.confirm({
        message: `${this.getPostTypes(this.post.type)} tidak akan tersimpan. Apakah anda yakin akan keluar?`,
        type: 'is-info',
        cancelText: 'Tidak',
        confirmText: 'Saya yakin',
        hasIcon: true,
        onConfirm: () => {
          this.resetData();
        },
        onCancel: () => {
          if (!this.isEmpty(oldIndex)) {
            this.tab = oldIndex;
          }
        }
      })
    }
  }
}
</script>

<style>
.btn-submit {
  border: none;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.btn-cancel {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>
